import { campaign } from "./campaign";

const collectedItems = [
  "Contact details you choose to submit, including name, email address, phone number, address, and message content.",
  "Volunteer, event, petition, donation interest, or other campaign participation details you provide.",
  "Basic website analytics such as browser type, device type, referring pages, pages viewed, and approximate location derived from standard logs.",
];

const useItems = [
  "Respond to questions, volunteer offers, event requests, and other messages.",
  "Send campaign updates by email or text only when you have provided the relevant consent.",
  "Maintain records, improve the website, protect the site from abuse, and comply with legal obligations.",
];

export default function PrivacyPolicy() {
  return (
    <main className="bg-[#f7f1e6] px-4 py-16 text-[#17344f] sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl rounded-[2rem] bg-white p-8 shadow-2xl lg:p-12">
        <p className="text-sm font-black uppercase tracking-[0.2em] text-[#c74d2d]">Privacy Policy</p>
        <h1 className="mt-3 text-4xl font-black text-[#0b2f58]">{campaign.committee}</h1>
        <p className="mt-4 text-sm font-bold text-[#64748b]">Effective date: May 5, 2026</p>
        <p className="mt-6 leading-8 text-[#425d70]">
          This Privacy Policy explains how {campaign.committee} collects, uses, and protects information submitted through this website and campaign forms.
        </p>

        <section className="mt-10">
          <h2 className="text-2xl font-black text-[#0b2f58]">Information we collect</h2>
          <ul className="mt-4 list-disc space-y-3 pl-6 leading-7 text-[#425d70]">
            {collectedItems.map((item) => <li key={item}>{item}</li>)}
          </ul>
        </section>

        <section className="mt-10">
          <h2 className="text-2xl font-black text-[#0b2f58]">How we use information</h2>
          <ul className="mt-4 list-disc space-y-3 pl-6 leading-7 text-[#425d70]">
            {useItems.map((item) => <li key={item}>{item}</li>)}
          </ul>
        </section>

        <section className="mt-10">
          <h2 className="text-2xl font-black text-[#0b2f58]">Mobile information and SMS consent</h2>
          <p className="mt-4 leading-8 text-[#425d70]">
            SMS opt-in is optional. We will not share your opt-in to an SMS campaign with any third party for purposes unrelated to providing you with the services of that campaign. We may share personal data, including SMS opt-in or consent status, with vendors that help provide messaging services, including platform providers, phone companies, and other vendors who assist with text message delivery.
          </p>
          <p className="mt-4 leading-8 text-[#425d70]">
            All of the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties. We do not sell, rent, or share mobile phone numbers or SMS consent status for advertising or promotional purposes.
          </p>
        </section>

        <section className="mt-10">
          <h2 className="text-2xl font-black text-[#0b2f58]">Sharing and service providers</h2>
          <p className="mt-4 leading-8 text-[#425d70]">
            We may share limited information with service providers who help operate the website, process forms, host data, deliver email or text messages, process contributions, maintain security, or comply with law. Those providers are expected to use information only to support the campaign services requested.
          </p>
        </section>

        <section className="mt-10">
          <h2 className="text-2xl font-black text-[#0b2f58]">Your choices</h2>
          <p className="mt-4 leading-8 text-[#425d70]">
            You may opt out of campaign text messages by replying STOP. You may request help by replying HELP. You may contact us at <a href={`mailto:${campaign.email}`} className="font-bold text-[#0b2f58] underline">{campaign.email}</a> to update or request deletion of information where permitted by law.
          </p>
        </section>
      </div>
    </main>
  );
}